/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect, useState } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';
import { useParams, useHistory, useLocation } from 'react-router-dom';

import { globals as globalsSlice } from '../../app/globalsSlice';
import PageTitle from '../../components/PageTitle';
import { t } from '../../providers';
import { getLocale } from '../../providers';
import { me as meSlice } from '../AuthenticatedPage/authenticationSlice';
import FieldsMissingDialog from '../MyAccountPage/components/ChildAccounts/FieldsMissingDialog';
import ServicesList from './components/ServicesList/ServicesList';
import servicesItems from './servicesItems';

const useStyles = makeStyles(() => ({
    tabs: {
        '& .MuiTabs-scroller::-webkit-scrollbar-thumb': {
            backgroundColor: 'unset',
        },
        '& .MuiTab-root': {
            minWidth: '100px',
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
        },
    },
    tabContainer: {
        width: '100%',
    },
    profileTabContainer: {},
}));

const TRADEMARKS = 'trademark';
const DESIGNS = 'design';
const PATENTS = 'patents';

const OnlineServicesPage = () => {
    const classes = useStyles();
    const { service } = useParams();
    const location = useLocation();
    const history = useHistory();
    const me = useSelector(meSlice);
    const { globals } = useSelector(globalsSlice) || {};

    const [tabs, setTabs] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);

    const tabIndex = !!~tabs.indexOf(service) ? tabs.indexOf(service) : 0;
    const selectedLanguage = getLocale();

    useEffect(() => {
        const { authorities } = me;
        const allowedTabs = [];
        if (authorities && authorities.includes('ROLE_TRADEMARKS')) allowedTabs.push(TRADEMARKS);
        if (authorities && authorities.includes('ROLE_DESIGNS')) allowedTabs.push(DESIGNS);
        if (authorities && authorities.includes('ROLE_PATENTS')) allowedTabs.push(PATENTS);

        setTabs(allowedTabs); //set tabs depending on tabs allowed based on authorities role

        if (allowedTabs.length > 0) {
            if (!service || service === 'undefined') history.push(`/online-services/${allowedTabs[0]}`);
        } else {
            history.push('/');
        }
    }, [service, me, history]);

    const handleTabChange = (event, value) => {
        event.preventDefault();
        history.push(`/online-services/${tabs[value]}`);
    };

    const navigateTo = (event, path, external) => {
        event.preventDefault();
        const selectedLanguage = getLocale();

        if (path && external) {
            let newPath = path;
            if (!!newPath && !newPath.startsWith('http')) newPath = globals.ipo['fo.url'].concat(globals.ipo[path]);
            if (newPath.indexOf('?') >= 0) {
                newPath += `&lang=${selectedLanguage}`;
            } else {
                newPath += `?lang=${selectedLanguage}`;
            }
            if (!!newPath) window.open(newPath, '_blank');
        } else {
            if (path && location.pathname !== path) {
                history.push(path);
            }
        }
    };

    const navigateToProfile = (event) => {
        event.preventDefault();
        setDialogOpen(false);
        history.push('/my-account/profile-details');
    };

    const cancelMessage = (event) => {
        event.preventDefault();
        setDialogOpen(false);
    };

    return (
        <div>
            <PageTitle title={t('online.services.title')} details={t('online.services.description')} />
            <Tabs className={classes.tabs} value={tabIndex} onChange={handleTabChange} textColor="primary" aria-label={t('online.services.title')}>
                {tabs.map((tab, index) => (
                    <Tab
                        disableFocusRipple
                        id={`tab-${tab}-${index}`}
                        key={'tab-' + index}
                        label={t(tab + '.tab.title')}
                        style={{ textTransform: 'uppercase' }}
                        aria-selected={tabIndex === index ? 'true' : 'false'}
                        aria-controls={`online-services-tabpanel-${index}`}
                        role="tab"
                    />
                ))}
            </Tabs>
            {globals ? (
                <div
                    className={classes.profileTabContainer}
                    id={`online-services-tabpanel-${tabIndex}`}
                    aria-labelledby={`tab-${tabs[tabIndex]}-${tabIndex}`}
                    role="tabpanel">
                    {service && <ServicesList items={servicesItems[service]['services']} navigateTo={navigateTo} />}
                </div>
            ) : (
                <>
                    <CircularProgress aria-hidden="true" />
                    <Typography variant="srOnly" role="alert">
                        {t('loading.text')}
                    </Typography>
                </>
            )}
            <FieldsMissingDialog open={dialogOpen} onAccept={navigateToProfile} onCancel={cancelMessage} />
        </div>
    );
};

export default OnlineServicesPage;
